import React, { useState } from 'react';
import { User, Users, Plus, Check, Trash2, Edit2, Sparkles } from 'lucide-react';

export function AvatarProfilesManager({
  profiles = [],
  activeProfileId,
  onSelectProfile,
  onCreateProfile,
  onDeleteProfile,
  isVideoDuoMode = false,
  onToggleDuoMode,
  duoSecondaryProfileId,
  onSelectDuoSecondary
}) {
  const [isCreating, setIsCreating] = useState(false);
  const [newProfileName, setNewProfileName] = useState('');

  const handleCreate = (e) => {
    e.preventDefault();
    if (newProfileName.trim() && onCreateProfile) {
      onCreateProfile(newProfileName.trim());
      setNewProfileName('');
      setIsCreating(false);
    }
  };

  return (
    <div style={{
      padding: '14px',
      background: 'linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.01) 100%)',
      borderRadius: '12px',
      border: '1px solid rgba(255,255,255,0.08)',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Users size={13} color="#c084fc" /> Biblioteca de Avatares
        </span>
        <button
          type="button"
          onClick={() => setIsCreating(true)}
          style={{
            background: 'rgba(168,85,247,0.15)',
            border: '1px solid rgba(192,132,252,0.4)',
            color: '#c084fc',
            borderRadius: '6px',
            padding: '2px 8px',
            fontSize: '10px',
            fontWeight: 700,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '3px'
          }}
        >
          <Plus size={11} /> Nuevo
        </button>
      </div>

      {/* Profiles List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {profiles.map((p) => {
          const isActive = p.id === activeProfileId;
          const isDuoSecondary = p.id === duoSecondaryProfileId;

          return (
            <div
              key={p.id}
              onClick={() => onSelectProfile(p.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '6px 10px',
                borderRadius: '8px',
                background: isActive ? 'rgba(168,85,247,0.18)' : '#141724',
                border: isActive ? '1px solid rgba(192,132,252,0.5)' : '1px solid rgba(255,255,255,0.06)',
                cursor: 'pointer',
                transition: 'all 0.15s ease'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <img
                  src={p.avatarSrc || '/avatar_base.jpg'}
                  alt={p.name}
                  style={{ width: '28px', height: '28px', borderRadius: '6px', objectFit: 'cover' }}
                />
                <div>
                  <div style={{ fontSize: '12px', fontWeight: 600, color: isActive ? '#f8fafc' : '#cbd5e1' }}>
                    {p.name}
                  </div>
                  <div style={{ fontSize: '9px', color: '#64748b' }}>
                    {p.voiceAudioUrl ? '🎙️ Voz lista' : 'Sin voz'} · {1 + (p.angles?.length || 0)} ángulo(s)
                  </div>
                </div>
              </div>

              {isActive && (
                <span style={{ fontSize: '10px', color: '#10b981', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <Check size={12} /> Activo
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* Input Crear Nuevo */}
      {isCreating && (
        <form onSubmit={handleCreate} style={{ display: 'flex', gap: '6px', marginTop: '2px' }}>
          <input
            type="text"
            value={newProfileName}
            onChange={(e) => setNewProfileName(e.target.value)}
            placeholder="Nombre (ej. Dra. Elena / Carlos Ventas)"
            autoFocus
            style={{
              flex: 1,
              background: '#0d0f17',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '6px',
              padding: '6px 8px',
              color: '#f8fafc',
              fontSize: '11px',
              outline: 'none'
            }}
          />
          <button
            type="submit"
            style={{
              background: '#10b981',
              border: 'none',
              borderRadius: '6px',
              padding: '6px 10px',
              color: '#fff',
              fontSize: '11px',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          >
            Crear
          </button>
          <button
            type="button"
            onClick={() => setIsCreating(false)}
            style={{
              background: 'transparent',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '6px',
              padding: '6px 8px',
              color: '#94a3b8',
              fontSize: '11px',
              cursor: 'pointer'
            }}
          >
            ✕
          </button>
        </form>
      )}

      {/* Modo Dúo / Diálogo entre dos avatares */}
      <div style={{
        marginTop: '4px',
        paddingTop: '8px',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
      }}>
        <div
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
          onClick={() => onToggleDuoMode(!isVideoDuoMode)}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Users size={13} color="#ff9101" />
            <span style={{ fontSize: '11px', fontWeight: 600, color: '#f8fafc' }}>
              Modo Dúo / Diálogo en Video
            </span>
          </div>
          <input
            type="checkbox"
            checked={isVideoDuoMode}
            onChange={(e) => onToggleDuoMode(e.target.checked)}
            style={{ width: '15px', height: '15px', accentColor: '#ff9101', cursor: 'pointer' }}
          />
        </div>

        {isVideoDuoMode && profiles.length > 1 && (
          <div>
            <label style={{ fontSize: '9px', color: '#94a3b8', textTransform: 'uppercase', fontWeight: 700 }}>
              Segundo Avatar para el Diálogo:
            </label>
            <select
              value={duoSecondaryProfileId || ''}
              onChange={(e) => onSelectDuoSecondary(e.target.value)}
              style={{
                width: '100%',
                background: '#0d0f17',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '6px',
                padding: '4px 8px',
                color: '#f8fafc',
                fontSize: '11px',
                marginTop: '4px',
                outline: 'none'
              }}
            >
              <option value="">Selecciona co-protagonista...</option>
              {profiles.filter((p) => p.id !== activeProfileId).map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
}
